import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Container, Stack, Typography } from '@mui/material'

function Footer() {
    return (
        <Box
            className="page-footer"
            component="footer"
            sx={{
                py: { xs: 2.5, md: 3 },
                px: { xs: 2.5, md: 4 },
                backgroundColor: '#0055A2 !important',
                background: '#0055A2 !important',
                color: '#FFFFFF !important',
                width: '100%',
                boxSizing: 'border-box',
            }}
        >
            <Container disableGutters maxWidth="xl">
                <Stack
                    alignItems={{ xs: 'flex-start', md: 'center' }}
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    spacing={{ xs: 2, md: 3 }}
                >
                    {/* Left: Brand Logo & Description */}
                    <Stack
                        spacing={0.5}
                        sx={{ maxWidth: { xs: '100%', md: '560px' } }}
                    >
                        <Link
                            style={{
                                textDecoration: 'none',
                                color: '#FFFFFF',
                                display: 'inline-block',
                            }}
                            to="/"
                        >
                            <Typography
                                component="h2"
                                sx={{
                                    fontSize: '1.8rem',
                                    fontWeight: 700,
                                    letterSpacing: '-0.4px',
                                    color: '#FFFFFF !important',
                                    m: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontFamily: 'inherit',
                                }}
                                variant="h5"
                            >
                                <i
                                    style={{
                                        fontStyle: 'italic',
                                        fontWeight: 700,
                                        color: '#FFFFFF',
                                    }}
                                >
                                    my
                                </i>
                                Academic
                            </Typography>
                        </Link>
                        <Typography
                            sx={{
                                color: '#FFFFFF !important',
                                fontSize: { xs: '0.9rem', md: '0.95rem' },
                                fontWeight: 500,
                                lineHeight: 1.45,
                            }}
                            variant="body1"
                        >
                            myAcademic is reinventing higher education to
                            improve learning outcomes with active student
                            engagement.
                        </Typography>
                    </Stack>

                    {/* Right: Contact Us Hyperlink & Copyright Line (Vertical & Right Aligned) */}
                    <Stack
                        alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
                        direction="column"
                        spacing={1}
                        sx={{ textAlign: { xs: 'left', sm: 'right' } }}
                    >
                        <Stack direction="row" spacing={3}>
                            <Link
                                style={{
                                    color: '#FFFFFF',
                                    textDecoration: 'none',
                                    fontSize: '0.95rem',
                                    fontWeight: 700,
                                    transition: 'opacity 0.2s ease',
                                }}
                                to="/privacy-policy"
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                style={{
                                    color: '#FFFFFF',
                                    textDecoration: 'none',
                                    fontSize: '0.95rem',
                                    fontWeight: 700,
                                    transition: 'opacity 0.2s ease',
                                }}
                                to="/terms-of-service"
                            >
                                Terms of Service
                            </Link>
                            <Link
                                style={{
                                    color: '#FFFFFF',
                                    textDecoration: 'none',
                                    fontSize: '0.95rem',
                                    fontWeight: 700,
                                    transition: 'opacity 0.2s ease',
                                }}
                                to="/contact-us"
                            >
                                Contact Us
                            </Link>
                        </Stack>

                        <Typography
                            sx={{
                                color: 'rgba(255, 255, 255, 0.95) !important',
                                fontSize: { xs: '0.85rem', md: '0.9rem' },
                                fontWeight: 500,
                            }}
                            variant="body1"
                        >
                            © {new Date().getFullYear()} Copyright:
                            myacademic.org
                        </Typography>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    )
}

export default Footer
